import HomeRoutes from './routes_home';
import textCreateRoutes from './routes_textcreate_old';
import digitalRoutes from './routes_digital_old';
import imageCreateRoutes from './routes_imagecreate_old';
import textCreateUserRoutes from './routes_textcreateUser';
import digitalUserRoutes from './routes_digitalUser';
import imageCreateUserRoutes from './routes_imagecreateUser';
import exceptionRoutes from './routes_exception';
import assetsLibraryRoutes from './routes_assetLibrary';
import couponRoutes from './routes_coupon';
import coHomeRoutes from './routes_coExtensionHome';
import orderRoutes from './routes_order';
import helpDocRoutes from './routes_helpDoc';
import userCenterRoutes from './routes_userCenter';
import taskCenterRoutes from './routes_taskCenter';
import v2AssetsRoutes from './routes_v2_assetsAndMarket';
import PlatformV2Routes from './routes_v2_platform';
import FindV2Routes from './routes_v2_find';

const routes = [

    // 包含userid的路由文件
    ...textCreateUserRoutes,
    ...digitalUserRoutes,
    ...imageCreateUserRoutes,
    ...taskCenterRoutes,

    ...HomeRoutes,
    ...assetsLibraryRoutes,
    ...couponRoutes,
    ...orderRoutes,

    // 共拓
    ...coHomeRoutes,
    // 帮助文档
    ...helpDocRoutes,
    ...userCenterRoutes,
    ...taskCenterRoutes,
    ...v2AssetsRoutes,

    // 改版2.0的路由
    ...PlatformV2Routes,
    ...FindV2Routes,

    // old版本用来配置不带uid的参数，需要在常规路由后面
    ...textCreateRoutes,
    ...digitalRoutes,
    ...imageCreateRoutes,

    // 404页面必须在最后面
    ...exceptionRoutes
];

export default routes;
